<template>
  <div class="wrap">
    <div class="title">
      <div class="bar mr-5"></div>
      <div class="text">
        <slot name="title" />
      </div>
      <div :class="['packup',{'is-opened':isOpen}]" @click="packup">{{isOpen?'展开':'收起'}}<i class="el-submenu__icon-arrow el-icon-arrow-down bbqq"></i></div>
    </div>
    <transition name="el-fade-in-linear">
      <div class="main" v-show="!isOpen">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: '',
  components: {

  },
  props: {

  },
  data() {
    return {
      isOpen: false,
      pageNum: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    packup() {
      this.isOpen = !this.isOpen
    }
  },
};
</script>

<style scoped lang="scss">
.wrap {
  // padding: 12px 10px;
  padding: 12px 0px;
  background-color: #fff;
  .title {
    // padding: 20px 0;
    display: flex;
    height: 42px;
    background: #F8F8F9;
    padding: 0 24px;
    display: flex;
    align-items: center;
    div {
      font-size: 12px;
    }
    .bar {
      width: 4px;
      height: 12px;
      background-color: #1890ff;    
      margin-right: 8px;
    }
    .text {
      color: #333;
      font-size: 14px;
      font-weight: bold;
      line-height: 20px;
    }
    .packup {
      margin-left: auto;
      position: relative;
      // width: 60px;
      cursor: pointer;
      &.is-opened .el-submenu__icon-arrow {
        transform: rotate(180deg);
      }
    }
  }
  .main{
    font-size: 12px;
  }
}
.bbqq{
      margin-top: -5px;
    position: relative;
    margin: 0;
    top: 0;
    right: 0;
}
</style>
